import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Api, { exceptionNotificationAPI } from "../../services/api";

export default function AnnualPopupMessageModal({ userObject }) {
    const [messages, setMessages] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [agreed, setAgreed] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!userObject?.selectedReportYearID) return;

        Api.get(`AnnualPopupMessage/getPendingForUser?reportYearID=${userObject.selectedReportYearID}`)
            .then((result) => {
                if (result?.data?.response?.length > 0) {
                    setMessages(result.data.response);
                    setCurrentIndex(0);
                }
            })
            .catch((error) => exceptionNotificationAPI(error));
    }, [userObject?.selectedReportYearID]);

    const message = messages[currentIndex] ?? null;
    const total = messages.length;
    const position = currentIndex + 1;

    const handleSignOff = async () => {
        setLoading(true);
        try {
            await Api.post(`AnnualPopupMessage/signOff?annualPopupMessageID=${message.annualPopupMessageID}`);
            setAgreed(false);
            setCurrentIndex((prev) => prev + 1);
        } catch (error) {
            exceptionNotificationAPI(error);
        } finally {
            setLoading(false);
        }
    };

    if (!message) return null;

    return (
        <Modal
            show
            backdrop="static"
            keyboard={false}
            centered
            size="xl"
            onHide={() => {}}
        >
            <Modal.Header>
                <div className="d-flex align-items-center justify-content-between w-100">
                    {/* <div className="d-flex align-items-center gap-2">
                        <span
                            className="d-inline-block rounded-pill"
                            style={{ width: 32, height: 6, backgroundColor: "var(--bs-primary)" }}
                        />
                        <small className="text-uppercase text-muted fw-medium">
                            RY {userObject.selectedReportYear}
                        </small>
                    </div> */}

                    {total > 1 && (
                        <div className="d-flex align-items-center gap-2">
                            {Array.from({ length: total }).map((_, i) => (
                                <span
                                    key={i}
                                    className="d-inline-block rounded-circle"
                                    style={{
                                        width: 10,
                                        height: 10,
                                        backgroundColor: i < position
                                            ? "var(--bs-primary)"
                                            : "#dee2e6",
                                        transition: "background-color 0.3s",
                                    }}
                                />
                            ))}
                            <small className="text-muted ms-1 fw-medium">
                                {position} of {total}
                            </small>
                        </div>
                    )}
                </div>
            </Modal.Header>

            <Modal.Body>
                <Modal.Title className="mb-3 fw-bold">
                    {message.title}
                </Modal.Title>

                <div
                    className="p-3 rounded bg-light text-dark"
                    style={{ maxHeight: 320, overflowY: "auto", fontSize: "0.875rem", lineHeight: 1.7 }}
                    dangerouslySetInnerHTML={{ __html: message.body }}
                />

                <div className="mt-4 p-3 border rounded bg-light">
                    <Form.Check
                        type="checkbox"
                        id="signoff-agree"
                        checked={agreed}
                        onChange={(e) => setAgreed(e.target.checked)}
                        label={`I confirm that I have read, understood, and agree to the above information.`}
                    />
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
                <small className="text-muted">
                    {total > 1
                        ? `${total - position} confirmation${total - position !== 1 ? "s" : ""} remaining after this one`
                        : "Last confirmation"}
                </small>
                <Button
                    variant="primary"
                    onClick={handleSignOff}
                    disabled={!agreed || loading}
                >
                    {loading ? "Confirming..." : position < total ? "Confirm & Next" : "Confirm"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
